const bannerBack = () => {
  let banner = document?.querySelector('.banner-back'),
    topBlock = document?.querySelector('header'),
    close = document?.querySelector('.banner-back__close'),
    bottomBlock = document?.querySelector('.form');
    
  if (banner) {
    window.addEventListener('scroll', function () {
      if (topBlock.getBoundingClientRect().bottom < -250) { 
        banner.classList.add('banner-fixed');
      } else {
        banner.classList.remove('banner-fixed');
      }

      if (bottomBlock.getBoundingClientRect().top - 100 < banner.getBoundingClientRect().bottom) { 
        banner.classList.remove('banner-fixed');
      }
    });

    close?.addEventListener('click', function () {
      banner.style.opacity = "0";
    });
  }
};

export default bannerBack;
